<div class="failure-page">
  <div class="failure-card">
    <!-- Icon -->
    <div class="failure-icon-wrapper">
      <mat-icon class="failure-icon">error_outline</mat-icon>
    </div>

    <!-- Heading -->
    <h1 class="failure-heading">Payment Failed</h1>
    <p class="failure-subtitle">
      We couldn't complete your payment. No charges have been made to your account.
    </p>

    <!-- Optional error message from URL -->
    <div *ngIf="errorMessage" class="error-detail">
      <mat-icon class="error-detail-icon">info</mat-icon>
      <span>{{ errorMessage }}</span>
    </div>

    <!-- Reassurance -->
    <p class="reassurance-text">
      If you believe this is an error or need assistance, please contact our support team.
    </p>

    <!-- Actions -->
    <div class="actions">
      <a routerLink="/home/manage-subscription" class="btn-retry">
        <mat-icon>refresh</mat-icon>
        Try Again
      </a>
      <a routerLink="/home/dashboard" class="btn-dashboard">
        <img src="../../assets/image/Shape.png" alt="" class="btn-icon" />
        Go to Dashboard
      </a>
    </div>
  </div>
</div>
